import { useEffect } from 'react';
import { useRegisterComponent } from '../../orchestrator';
import { useLoginRecoveryOptionsContext } from '../contexts/LoginRecoveryOptionsContext';
import { useLoginRecoveryOptions } from './utility';

type UseGoogleOneTapProps = {
  email?: string;
};

export const useGoogleOneTap = ({ email }: UseGoogleOneTapProps) => {
  useRegisterComponent(useGoogleOneTap.name);

  const { setLoginRecoveryOptions } = useLoginRecoveryOptionsContext();

  const buildLoginRecoveryOptions = useLoginRecoveryOptions();

  useEffect(() => {
    if (!email) {
      return;
    }

    const loginRecoveryOptions = buildLoginRecoveryOptions(email);
    setLoginRecoveryOptions(loginRecoveryOptions);
  }, [email, setLoginRecoveryOptions, buildLoginRecoveryOptions]);
};
